import React, { useState, useEffect } from "react";
import { Checkbox, Toolbar, Button, Message, Groupper, Field, Dropdown, Modal, useFrontier, Icon, Input, Loader, Header, Table, Stat } from 'react-frontier2';
import { addCommas, bindFormChange, formatCommission, isActive, unix, getDaysAvailable, bindClick, roundNumber, fromUnix } from "@arema/components/Util";
import { DeliveryMethod, EventDateData, PaymentMethod, SetLoading } from "@arema/components/Classes";
import { EventSectionProps } from '../../AdminClasses'
import { Seatmap, SectionHoldModal, UserLog, SearchDeliveryModal, EventDateStatusModal } from "../../components";
import { Link, useNavigate } from "react-router-dom";
import { useUser } from "../../AdminHooks";
import { arrayMoveImmutable } from "array-move";
import { SegmentControl } from "@arema/components";
import { useTranslation } from "react-i18next";
import SortableList, { SortableItem } from "react-easy-sort";
import API from "../../API";
import moment from "moment";
import Validator from "@arema/components/Validator";
import classNames from "classnames";
import UserAccess from "../../UserAccess";

interface EventDateParams extends EventSectionProps {
	params: {
		id: number
	}
}

interface SelectedSection {
	section_id: number,
	section_name: string,
	venue_id: number,
	date_start: number,
	date_end: number,
	numbered: boolean,
	published: boolean,
	ticket_count: number,
	date_ticket_count: number,
	infinite: boolean,
}

interface SelectedPrice {
	price_id?: number,
	section_id?: number,
	price_name: string,
	cost: number,
	min_tickets: number,
	max_tickets: number,
	multiple: number,
	commission: number,
	date_start: number,
	date_end: number,
	date_start_pdv: number,
	date_end_pdv: number,
	ticket_limit?: number,
	needs_comment?: boolean,
	published_web?: boolean,
	published_pdv?: boolean,
	sort_order?: boolean,
	active?: boolean,
	venue_only?: boolean,
	restricted?: boolean,
	days_available?: boolean[],
}

interface SelectedPayment {
	edit: boolean,
	method_id: number,
	method_name: string,
	date_start: number,
	date_end: number,
	force: boolean,
	change_commission?: boolean,
	commission_percent?: number,
	commission_amount?: number,
	original_commission_percent?: number,
	original_commission_amount?: number,
}

interface SelectedDelivery {
	edit: boolean,
	delivery_id: number,
	method_name: string,
	delivery_cost: number,
	ticket_type: number,
	needs_location: boolean,
	date_start: number,
	date_end: number,
}

interface SelectedSeatmap {
	section_id: number,
	section_name: string,
}

interface RefundRequest {
	sent: boolean,
	refundable_web: boolean,
	refundable_pdv: boolean,
	refundable_complete: boolean,
	comments: string
}

interface EventDateStatus {
	status_id: number,
	status_name: string,
}

enum ModalType {
	DELETE_EVENTDATE = 1,
	EDIT_SECTION = 2,
	SECTION_HOLD = 3,
	PRICE_SORT = 4,
	SECTION_SORT = 5,
	SECTION_ADD = 6,
	DELIVERY_METHODS = 7,
	EDIT_SECTION_TICKET_COUNT = 8,
	REMOVE_DATE_SECTION = 9,
	SECTION_STATUS = 10,
}

var EventDateComponent = (props: EventDateParams)=>{
	var navigate = useNavigate();
	var { hasAccess } = useUser();
	var { t } = useTranslation();
	var { Toast } = useFrontier();
	var [date, setDate] = useState<EventDateData>();
	var [paymentMethods, setPaymentMethods] = useState<PaymentMethod[]>(null);
	var [deliveryMethods, setDeliveryMethods] = useState<DeliveryMethod[]>(null);
	var [eventDateStatus, setEventDateStatus] = useState<EventDateStatus[]>(null);
	var [loadingSections, setLoadingSections] = useState<boolean>(false);
	var [datePrompts, setDatePrompts] = useState<string[]>(null);
	var [modalPrompts, setModalPrompts] = useState<string[]>(null);
	var [shownSectionPrices, setShownSectionPrices] = useState<number[]>([]);

	var [addPaymentModal, setAddPaymentModal] = useState<boolean>(false);
	var [addDeliveryModal, setAddDeliveryModal] = useState<boolean>(false);
	var [selectedSection, setSelectedSection] = useState<SelectedSection>(null)
	var [selectedPayment, setSelectedPayment] = useState<SelectedPayment>(null);
	var [selectedDelivery, setSelectedDelivery] = useState<SelectedDelivery>(null);
	var [selectedSeatmap, setSelectedSeatmap] = useState<SelectedSeatmap>(null);
	var [editingPrice, setEditingPrice] = useState<SelectedPrice>(null);
	var [confirmPaymentModal, setConfirmPaymentModal] = useState<boolean>(false);
	var [confirmDeliveryModal, setConfirmDeliveryModal] = useState<boolean>(false);
	var [refundRequest, setRefundRequest] = useState<RefundRequest>(null);
	var [refundRequestModal, setRefundRequestModal] = useState<boolean>(false);

	var [sendingQueue, setSendingQueue] = useState<boolean>(false);
	var [shownModal, setShownModal] = useState<ModalType>(null);
	var [deleteConfirm, setDeleteConfirm] = useState<string>('');

	var [pricesSort, setPricesSorted] = useState<SelectedPrice[]>([]);
	var [sectionsSort, setSectionsSorted] = useState([]);

	var [pricePercentageModal, setPricePercentageModal] = useState<boolean>(false);
	var [pricePercentage, setPricePercentage] = useState<string>(null);


	useEffect(()=>{
		if(!date){
			API.getDate(props.params.id, ['delivery', 'delivery', 'payment_methods', 'prices', 'sections', 'venue'], ['date_check']).then(res=>{
				if(res.error){
					Toast.error(res.message)
					return navigate(-1);
				}
				if(res.data.pdv_payment_methods){
					for(var i of res.data.pdv_payment_methods){
						if(parseFloat(i.commission_percent)<=1) i.commission_percent = (parseFloat(i.commission_percent) * 100).toString();
					}
				}
				setDate(res.data);
			}).catch(err=>{
				Toast.error('Hubo un error inesperado cargando el calendario. (LCL-1)');
				return navigate(-1);
			})
		}
		if(!paymentMethods){
			API.getEventsQL(['payment_methods', 'delivery_methods', 'event_date_status']).then(res=>{
				if(res.error) return Toast.error(`${res.message} (LCL-QL-2)`);
				setPaymentMethods(res.data.payment_methods);
				setDeliveryMethods(res.data.delivery_methods);
				setEventDateStatus(res.data.event_date_status)
			}).catch(err=>{
				Toast.error('Hubo un error cargando los métodos de pago. (LCL-QL-1)');
			})
		}
	}, []);

	var editDate = (setLoading: SetLoading)=>{
		var { valid, prompts, form } = Validator({
			date: date.date,
			published: date.published ? 1 : 0,
			active_web: date.active_web ? 1 : 0,
			active_pdv: date.active_pdv ? 1 : 0,
			status_id: date.status_id
		}, {
			date: ['number'],
		});

		setDatePrompts(prompts);
		if(!valid) return;
		setLoading(true);
		API.editDate(date.date_id, {
			date: form.date,
			published: form.published,
			active_web: form.active_web,
			active_pdv: form.active_pdv,
			status_id: form.status_id,
		}).then(res=>{
			if(res.error) return setDatePrompts([res.message]);
			return Toast.success('Se ha guardado el calendario.');
		}).catch(err=>{
			return setDatePrompts(['Hubo un error inesperado guardando el calendario (LCL-2)']);
		}).finally(()=>{
			setLoading(false);
		})
	}

	var addSection = (section_id: number)=>{
		var sec = date.venue.sections.find(a=>a.section_id == section_id);
		if(!sec) return;
		var today = moment().startOf('day');
		setModalPrompts(null);
		setShownModal(ModalType.EDIT_SECTION);
		setSelectedSection({
			section_id: sec.section_id,
			section_name: sec.section_name,
			venue_id: sec.venue_id,
			date_start: null,
			date_end: null,
			numbered: sec.numbered,
			infinite: sec.infinite,
			ticket_count: sec.ticket_count,
			date_ticket_count: null,
			published: true,
		})
	}

	var saveSection = (setLoading: SetLoading)=>{
		if(!selectedSection) return;
		var { valid, prompts } = Validator(selectedSection, {
			section_id: ['number'],
			date_start: [
				{ rule: 'number', skipEmpty: true, prompt: 'Favor de seleccionar la fecha de inicio' },
			],
			date_end: [
				{ rule: 'number', skipEmpty: true, prompt: 'Favor de seleccionar la fecha fin.' },
				{ rule: ()=>{
					if(selectedSection.date_start===null || selectedSection.date_end===null) return true;
					return selectedSection.date_start < selectedSection.date_end;
				}, prompt: 'La fecha fin no puede ser antes de la fecha inicial.' },
			],
		});

		setModalPrompts(prompts);
		if(!valid) return;
		setLoading(true);
		API.addDateSection(date.date_id, selectedSection.section_id, selectedSection.date_start, selectedSection.date_end).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			Toast.success(`Se ha guardado la sección "${selectedSection.section_name}"`);
			var dt = { ...date };
			var sx = dt.sections.findIndex(a=>a.section_id == selectedSection.section_id);
			if(sx == -1){
				dt.sections.push({
					section_id: selectedSection.section_id,
					section_name: selectedSection.section_name,
					venue_id: selectedSection.venue_id,
					date_start: selectedSection.date_start,
					date_end: selectedSection.date_end,
					active: isActive(selectedSection.date_start, selectedSection.date_end),
					description: '',
					numbered: selectedSection.numbered,
					infinite: !!selectedSection.infinite,
					ticket_count: selectedSection.ticket_count,
					date_ticket_count: selectedSection.date_ticket_count,
					published: true,
					prices: []
				});
			}else{
				dt.sections[sx].date_start = selectedSection.date_start;
				dt.sections[sx].date_end = selectedSection.date_end;
				dt.sections[sx].active = isActive(selectedSection.date_start, selectedSection.date_end);
				dt.sections[sx].published = selectedSection.published;
				dt.sections[sx].infinite = selectedSection.infinite;
			}
			setDate(dt);
			setSelectedSection(null);
		}).catch(err=>{
			setModalPrompts(['Hubo un error inesperado agregando la sección.']);
		}).finally(()=>{
			setLoading(false);
		})
	}

	var editSection = (section_id: number)=>{
		return ()=>{
			var section = date.sections.find(a=>a.section_id == section_id);
			if(!section) return;
			setModalPrompts(null);
			setShownModal(ModalType.EDIT_SECTION);
			setSelectedSection({
				section_id,
				section_name: section.section_name,
				venue_id: section.venue_id,
				numbered: section.numbered,
				date_start: section.date_start,
				date_end: section.date_end,
				ticket_count: section.ticket_count,
				date_ticket_count: section.date_ticket_count,
				infinite: !!section.infinite,
				published: section.published
			});
		}
	}

	var editSectionTicketCount = (section_id: number)=>{
		return ()=>{
			var section = date.sections.find(a=>a.section_id == section_id);
			if(!section) return;
			setModalPrompts(null);
			setShownModal(ModalType.EDIT_SECTION_TICKET_COUNT);
			setSelectedSection({
				section_id,
				section_name: section.section_name,
				venue_id: section.venue_id,
				numbered: section.numbered,
				date_start: section.date_start,
				date_end: section.date_end,
				ticket_count: section.ticket_count,
				date_ticket_count: section.date_ticket_count,
				infinite: !!section.infinite,
				published: section.published
			});
		}
	}

	var openModalSortSections = ()=>{
		setModalPrompts(null);
		setShownModal(ModalType.SECTION_SORT);
		setSectionsSorted([...date.sections])
	}

	const onSortSectionEnd = (oldIndex: number, newIndex: number)=>{
		setSectionsSorted((array)=>arrayMoveImmutable(array, oldIndex, newIndex));
	};
	
	var onSaveSectionOrder = (setLoading: SetLoading)=>{
		setLoading(true);
		var sectionOrder: { section_id: number, sort_order: number }[] = sectionsSort.map((q, index)=>({ section_id: q.section_id, sort_order: sectionsSort.length - index }))
		API.updateDateSectionsOrder(date.date_id, sectionOrder).then((res)=>{
			if(res.error) return setModalPrompts([res.message]);
			Toast.success("Se guardaron las secciones");
			setDate(d=>{
				var editedDate = { ...d };
				editedDate.sections = sectionOrder.map(sor=>{
					return editedDate.sections.find(s=>s.section_id === sor.section_id);
				})
				return editedDate;
			})
			setShownModal(null);
		}).catch(()=>{
			setModalPrompts(['Hubo un error guardando las secciones. (LCL-1)']);
		}).finally(()=>{
			setLoading(false);
		})
	}

	var onSaveSectionTicketCount = (setLoading: SetLoading)=>{
		if(!selectedSection) return;
		var { valid, prompts } = Validator(selectedSection, {
			section_id: [{ rule: 'empty', prompt: 'La sección no tiene un ID válido' }],
			date_ticket_count: [{ rule: 'number', label: 'Aforo' }],
		});
		
		setModalPrompts(prompts);
		if(!valid) return;

		setLoading(true);
		API.setDateSectionTicketCount(date.date_id, selectedSection.section_id, selectedSection.date_ticket_count).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			var sc = [...date.sections];
			var scx = sc.findIndex(a=>a.section_id===selectedSection.section_id);
			if(scx!=-1){
				sc[scx].date_ticket_count = selectedSection.date_ticket_count;
			}
			setDate(d=>({
				...d,
				sections: sc
			}));
			setShownModal(null);
			setSelectedSection(null);
			Toast.success('Se ha editado el aforo de la sección');
		}).catch(err=>{
			return setModalPrompts([t('common.unexpected_code', { code: 'LCL-EVDT-SSTKC' })]);
		}).finally(()=>{
			setLoading(false);
		})
	}

	var addSectionPrice = (section_id: number)=>{
		return ()=>{
			var section = date.sections.find(a=>a.section_id == section_id);
			if(!section) return;

			setEditingPrice({
				section_id,
				price_id: null,
				price_name: '',
				cost: null,
				commission: null,
				multiple: 1,
				min_tickets: 1,
				max_tickets: 10,
				date_start: section.date_start,
				date_end: section.date_end,
				date_start_pdv: null,
				date_end_pdv: null,
				published_pdv: true,
				published_web: true,
				days_available: [true, true, true, true, true, true, true],
				ticket_limit: null,
				needs_comment: false,
			})
		}
	}

	var editPrice = (section_id: number, price_id: number)=>{
		return ()=>{
			if(!hasAccess(UserAccess.DATES.EDIT_PRICES)) return;
			var sec = date.sections.find(a=>a.section_id == section_id);
			if(!sec) return;
			var price = sec.prices.find(a=>a.price_id == price_id);
			if(!price) return;
			setModalPrompts(null);
			setEditingPrice({
				section_id,
				...price,
				days_available: price.days_available || [true, true, true, true, true, true, true],
				ticket_limit: price.ticket_limit || null,
				needs_comment: price.needs_comment || null,
			});
		}
	}

	var openModalSortPrice = (section_id: number)=>{
		return ()=>{
			var section = date.sections.find(a=>a.section_id == section_id);
			setModalPrompts(null);
			setShownModal(ModalType.PRICE_SORT);
			setSelectedSection({
				section_id,
				section_name: section.section_name,
				venue_id: section.venue_id,
				numbered: section.numbered,
				date_start: section.date_start,
				date_end: section.date_end,
				ticket_count: section.ticket_count,
				date_ticket_count: section.date_ticket_count,
				infinite: !!section.infinite,
				published: section.published,
			});
			setPricesSorted([...section.prices])
		}
	}

	const onSortPriceEnd = (oldIndex: number, newIndex: number)=>{
		setPricesSorted((array)=>arrayMoveImmutable(array, oldIndex, newIndex));
	};
	
	var onSavePriceOrder = (setLoading: SetLoading)=>{
		setLoading(true);
		var priceOrder: { price_id: number, sort_order: number }[] = pricesSort.map((q, index)=>({ price_id: q.price_id, sort_order: pricesSort.length - index }))
		API.updatePriceOrder(priceOrder).then((res)=>{
			if(res.error) return setModalPrompts([res.message]);
			Toast.success("Se guardaron los precios");
			setDate(d=>{
				var editedDate = { ...d };
				editedDate.sections = editedDate.sections.map(s=>{
					if(s.section_id == selectedSection.section_id){
						s.prices = pricesSort.map(p=>{
							return s.prices.find(sp=>sp.price_id === p.price_id)
						});
					}
					return s;
				})
				return editedDate;
			})
			setShownModal(null);
		}).catch(()=>{
			setModalPrompts(['Hubo un error guardando los precios. (LCL-1)']);
		}).finally(()=>{
			setLoading(false);
		})
	}

	var savePriceEdit = (setLoading: SetLoading)=>{
		var { valid, prompts, form } = Validator(editingPrice, {
			commission: [
				{ rule: 'float', prompt: 'La comisión debe de ser un número.' }
			],
			cost: [
				{ rule: 'float', prompt: 'El precio del boleto no es válido.' }
			],
			price_name: [
				{ rule: 'minLength', params: [3], prompt: 'El nombre del precio debe de ser minimo 3 caracteres.' },
				{ rule: 'maxLength', params: [32], prompt: 'El nombre del precio debe de ser máximo 64 caracteres.' },
				{ rule: 'empty', prompt: 'Favor de ingresar el nombre del precio.' },
			],
			min_tickets: [
				{ rule: 'number', prompt: 'El número minimo de boletos no es válido.' },
				{ rule: 'min', params: [1], prompt: 'El minimo de boletos debe de ser minimo 1.' },
				{ rule: ()=>editingPrice.max_tickets > editingPrice.min_tickets, prompt: 'El máximo de boletos debe de ser menos que el minimo de boletos.' },
			],
			max_tickets: [
				{ rule: 'number', prompt: 'El número minimo de boletos no es válido.' }
			],
			multiple: [
				{ rule: 'number', prompt: 'El multiplo no es válido.' },
				{ rule: 'min', params: [1], prompt: 'El multiplo debe de ser mínimo 1.' }
			],
			// date_start: [
			// 	{ rule: 'number', prompt: 'Favor de seleccionar la fecha de inicio.' }
			// ],
			date_end: [
				// { rule: 'number', prompt: 'Favor de seleccionar la fecha fin.' },
				{ rule: ()=>{
					if(!editingPrice.date_end || !editingPrice.date_start) return true;
					return editingPrice.date_start < editingPrice.date_end
				}, prompt: 'La fecha fin no puede ser antes de la fecha inicial.', }
			],
			ticket_limit: [
				{ rule: 'number', prompt: 'El limite de boletos no es válido.', if: editingPrice.ticket_limit !== null },
				{ rule: 'min', params: [1], if: editingPrice.ticket_limit !== null  }
			],
		})
		setModalPrompts(prompts);
		if(!valid) return;
		setLoading(true);
		if(form.price_id){
			API.editPrice(form.price_id, form).then(res=>{
				if(res.error) return setModalPrompts([res.message]);
				var dt = { ...date };
				var sx = dt.sections.findIndex(a=>a.section_id == editingPrice.section_id);
				var px = dt.sections[sx].prices.findIndex(a=>a.price_id == form.price_id);
				dt.sections[sx].prices[px] = {
					price_id: form.price_id,
					section_id: form.section_id,
					price_name: form.price_name,
					cost: form.cost,
					commission: form.commission,
					min_tickets: form.min_tickets,
					max_tickets: form.max_tickets,
					multiple: form.multiple,
					date_start: form.date_start || null,
					date_end: form.date_end || null,
					date_start_pdv: form.date_start_pdv || null,
					date_end_pdv: form.date_end_pdv || null,
					available: isActive(form.date_start, form.date_end),
					published_pdv: form.published_pdv,
					published_web: form.published_web,
					restricted: form.restricted,
					venue_only: form.venue_only,
					days_available: form.days_available,
					ticket_limit: form.ticket_limit,
					needs_comment: form.needs_comment,
				}
				setDate(dt);
				setEditingPrice(null);
				Toast.success(`Se ha guardado el precio "${form.price_name}"`);
			}).catch(err=>{
				setModalPrompts(['Hubo un error inesperado guardando el precio. (LCL-1)']);
			}).finally(()=>{
				setLoading(false);
			});
		}else{
			API.addPrice(date.date_id, form.section_id, form).then(res=>{
				if(res.error) return setModalPrompts([res.message]);
				var dt = { ...date };
				var sx = dt.sections.findIndex(a=>a.section_id == editingPrice.section_id);
				dt.sections[sx].prices.push({
					price_id: res.data.price_id,
					section_id: form.section_id,
					price_name: form.price_name,
					cost: form.cost,
					commission: form.commission,
					min_tickets: form.min_tickets,
					max_tickets: form.max_tickets,
					multiple: form.multiple,
					date_start: form.date_start,
					date_end: form.date_end,
					date_start_pdv: form.date_start_pdv,
					date_end_pdv: form.date_end_pdv,
					available: isActive(form.date_start, form.date_end),
					published_pdv: form.published_pdv,
					published_web: form.published_web,
					venue_only: form.venue_only,
					restricted: form.restricted,
					days_available: form.days_available,
					ticket_limit: form.ticket_limit,
					needs_comment: form.needs_comment
				});
				setDate(dt);
				setEditingPrice(null);
				Toast.success(`Se ha agregado el precio "${form.price_name}"`);
			}).catch(err=>{
				setModalPrompts(['Hubo un error inesperado editando el precio. (LCL-2)']);
			}).finally(()=>{
				setLoading(false);
			});
		}
	}

	var addPaymentMethod = (method_id: number)=>{
		return ()=>{
			if(!hasAccess(UserAccess.DATES.EDIT_PAYMENT_METHODS)) return;
			var pm = date.payment_methods.find(a=>a.payment_method == method_id);
			var opm = paymentMethods.find(a=>a.method_id===method_id);
			if(pm){
				setSelectedPayment({
					edit: true,
					method_id: pm.payment_method,
					method_name: pm.method_name,
					date_start: pm.date_start,
					date_end: pm.date_end,
					force: pm.force_show,
					change_commission: (pm.date_commission_amount != null || pm.date_commission_percent != null),
					original_commission_amount: opm?.commission_amount || null,
					original_commission_percent: opm?.commission_percent ? opm?.commission_percent*100 : null,
					commission_amount: pm.date_commission_amount,
					commission_percent: pm.date_commission_percent === null ? null : pm.date_commission_percent * 100,
				});
			}else{
				var npm = paymentMethods.find(a=>a.method_id == method_id);
				if(!npm) return;
				setSelectedPayment({
					edit: false,
					method_id: npm.method_id,
					method_name: npm.method_name_internal,
					date_start: date.date_web_start,
					date_end: Math.max(date.date, date.date_web_end),
					force: false,
					change_commission: false,
					commission_amount: null,
					commission_percent: null,
					original_commission_amount: opm?.commission_amount,
					original_commission_percent: opm?.commission_percent ? opm?.commission_percent * 100 : null,
				});
			}
			setModalPrompts(null);
			setAddPaymentModal(true);
		}
	}

	var savePaymentMethod = (setLoading: SetLoading)=>{
		if(!hasAccess(UserAccess.DATES.EDIT_PAYMENT_METHODS)) return;
		if(!selectedPayment) return;
		var { valid, form, prompts } = Validator({ ...selectedPayment }, {
			method_id: [{ rule: 'number' }],
			date_start: [{ rule: 'number', skipEmpty: true }],
			date_end: [{ rule: 'number', skipEmpty: true }],
			...(selectedPayment.change_commission ? {
				commission_percent: [{ rule: 'min', params: [0] }],
				commission_amount: [{ rule: 'min', params: [0] }],
			} : {}),
		});

		form.commission_amount = (!form.change_commission || `${form.commission_amount}`.trim() === '') ? null : form.commission_amount;
		form.commission_percent = (!form.change_commission || `${form.commission_percent}`.trim() === '') ? null : (form.commission_percent / 100);

		setModalPrompts(prompts);
		if(!valid) return;
		setLoading(true);

		var opm = paymentMethods.find(a=>a.method_id===form.method_id);

		API.addDatePaymentMethod(date.date_id, form.method_id, form.date_start, form.date_end, form.force, form.commission_amount, form.commission_percent).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			Toast.success('Se ha guardado el método de pago');
			var dt = { ...date };
			dt.payment_methods = dt.payment_methods.filter(a=>a.payment_method != form.method_id);
			dt.payment_methods.push({
				date_id: date.date_id,
				active: isActive(form.date_start, form.date_end, true),
				payment_method: form.method_id,
				method_name: form.method_name,
				method_name_internal: form.method_name,
				force_show: form.force,
				date_start: form.date_start,
				date_end: form.date_end,
				commission_amount: opm?.commission_amount,
				commission_percent: opm?.commission_percent,
				date_commission_amount: form.commission_amount,
				date_commission_percent: form.commission_percent,
			});
			setDate(dt);
			setAddPaymentModal(false);
			setSelectedPayment(null);
		}).catch(err=>{
			setModalPrompts(['Hubo un error guardando el método de pago (LCL-PM-1)']);
		}).finally(()=>{
			setLoading(false);
		})
	}

	var removePaymentMethod = (setLoading: SetLoading)=>{
		if(!selectedPayment) return;
		setLoading(true);
		API.removePaymentMethod(date.date_id, selectedPayment.method_id).then(res=>{
			if(res.error) return Toast.error(res.message);
			Toast.success(`Se ha eliminado el método de pago "${selectedPayment.method_name}"`);
			var dt = { ...date };
			dt.payment_methods = dt.payment_methods.filter(a=>a.payment_method != selectedPayment.method_id);
			setDate(dt);
			setAddPaymentModal(false);
			setConfirmPaymentModal(false);
			setSelectedPayment(null);
		}).catch(err=>{
			Toast.error('Hubo un error inesperado eliminando el método de pago.');
		}).catch(err=>{
			setLoading(false);
		})
	}

	var addDeliveryMethod = (delivery: DeliveryMethod)=>{
		return ()=>{
			if(!hasAccess(UserAccess.DATES.EDIT_DELIVERY_METHODS)) return;
			var dd = date.delivery.find(a=>a.delivery_id===delivery.delivery_id);
			if(dd){
				setSelectedDelivery({
					edit: true,
					delivery_id: dd.delivery_id,
					method_name: dd.method_name,
					date_start: dd.date_start,
					date_end: dd.date_end,
					delivery_cost: dd.delivery_cost,
					needs_location: delivery.needs_location,
					ticket_type: delivery.ticket_type,
				});
			}else{
				setSelectedDelivery({
					edit: false,
					delivery_id: delivery.delivery_id,
					method_name: delivery.method_name,
					date_start: date.date_web_start,
					date_end: Math.max(date.date, date.date_web_end),
					delivery_cost: delivery.delivery_cost,
					needs_location: delivery.needs_location,
					ticket_type: delivery.ticket_type,
				});
			}
			setModalPrompts(null);
			setAddDeliveryModal(true);
		}
	}

	var saveDeliveryMethod = (setLoading: SetLoading)=>{
		if(!selectedDelivery) return;
		var { valid, prompts, form } = Validator(selectedDelivery, {
			delivery_id: ['number'],
			date_start: [
				{ rule: 'number', prompt: 'Favor de seleccionar la fecha de inicio.', skipEmpty: true }
			],
			date_end: [
				{ rule: 'number', prompt: 'Favor de seleccionar la fecha fin.', skipEmpty: true },
				{ rule: ()=>selectedDelivery.date_start < selectedDelivery.date_end, prompt: 'La fecha fin no puede ser antes de la fecha inicial.', skipEmpty: true }
			],
			delivery_cost: [
				{ rule: 'float', prompt: 'El costo no es válido' },
				{ rule: 'min', params: [0], prompt: 'El costo de entrega debe de ser por lo menos 0.' }
			]
		});
		setModalPrompts(prompts);
		if(!valid) return;
		setLoading(true);
		API.addDateDelivery(date.date_id, form.delivery_id, form.delivery_cost, form.date_start, form.date_end).then(res=>{
			if(res.error) return setModalPrompts([res.message]);

			var dt = { ...date };
			dt.delivery = dt.delivery.filter(a=>a.delivery_id != form.delivery_id);
			dt.delivery.push({
				delivery_id: form.delivery_id,
				delivery_cost: parseFloat(form.delivery_cost),
				method_name: selectedDelivery.method_name,
				ticket_type: selectedDelivery.ticket_type,
				ticket_type_name: null,
				needs_location: selectedDelivery.needs_location,
				date_start: form.date_start,
				date_end: form.date_end,
				active: isActive(form.date_start, form.date_end, true),
			});
			setDate(dt);

			setAddDeliveryModal(false);
			setSelectedDelivery(null);
		}).catch(err=>{
			return setModalPrompts(['Hubo un error inesperado agregando la forma de envío (LCL-1)']);
		}).finally(()=>{
			setLoading(false);
		})
	}

	var removeDelivery = (setLoading: SetLoading)=>{
		if(!selectedDelivery) return;
		setLoading(true);
		API.removeDateDelivery(date.date_id, selectedDelivery.delivery_id).then(res=>{
			if(res.error) return Toast.error(res.message);
			Toast.success(`Se ha eliminado la forma de envío "${selectedDelivery.method_name}"`);
			var dt = { ...date };
			dt.delivery = dt.delivery.filter(a=>a.delivery_id != selectedDelivery.delivery_id);
			setDate(dt);

			setAddDeliveryModal(false);
			setConfirmDeliveryModal(false);
			setSelectedDelivery(null);
		}).catch(err=>{
			Toast.error('Hubo un error inesperado eliminando la forma de entrega. (LCL-1)');
		}).finally(()=>{
			setLoading(false);
		})
	}

	var saveDateDates = (setLoading: SetLoading)=>{
		var { valid } = Validator(date, {
			date_web_start: ['number'],
			date_web_end: ['number'],
			date_pdv_start: ['number'],
			date_pdv_end: ['number'],
			scanner_start: ['number'],
			scanner_end: ['number'],
		});
		if(!valid) return Toast.error('Una o mas fechas del calendario no es válida.');
		setLoading(true);
		API.editDate(date.date_id, {
			date_web_start: date.date_web_start,
			date_web_end: date.date_web_end,
			date_pdv_start: date.date_pdv_start,
			date_pdv_end: date.date_pdv_end,
			scanner_start: date.scanner_start,
			scanner_end: date.scanner_end,
		}).then(res=>{
			if(res.error) return Toast.error(res.message);
			Toast.success('Se han guardado las fechas del calendario.');
		}).catch(err=>{
			Toast.error('Hubo un error guardando las fechas del calendario. (LCL-1)')
		}).finally(()=>{
			setLoading(false);
		})
	}

	var editSeatmap = (section_id: number)=>{
		return ()=>{
			var section = date.sections.find(a=>a.section_id == section_id);
			if(!section) return;
			if(!section.numbered) return Toast.error('Esta sección no es numerada.');
			setSelectedSeatmap({
				section_id,
				section_name: section.section_name,
			});
		}
	};

	var openHoldModal = (section_id: number)=>{
		return ()=>{
			var section = date.sections.find(a=>a.section_id == section_id);
			if(!section) return;
			if(section.infinite) return Toast.error('Esta sección es infinita y no puede tener bloqueos');
			if(section.numbered) return Toast.error('Una sección numerado no puede tener bloqueo de boletos');
			setSelectedSection(section);
			setShownModal(ModalType.SECTION_HOLD);
		}
	};

	var showRefundRequest = ()=>{
		if(refundRequest && refundRequest.sent) return;
		setRefundRequest({
			sent: false,
			refundable_web: !!date.refundable_web,
			refundable_pdv: !!date.refundable_pdv,
			refundable_complete: !!date.refundable_complete,
			comments: ''
		});
		setRefundRequestModal(true);
	}

	var sendRefundableRequest = (setLoading: SetLoading)=>{
		var req: RefundRequest = refundRequest ? { ...refundRequest } : {
			sent: false,
			refundable_web: false,
			refundable_pdv: false,
			refundable_complete: false,
			comments: ''
		};
		if(!req.refundable_pdv && !req.refundable_web){
			req.refundable_complete = false;
		}

		if((!!req.refundable_complete) == (!!date.refundable_complete) && (!!req.refundable_pdv) == (!!date.refundable_pdv) && (!!req.refundable_web) == (!!date.refundable_web)){
			return setModalPrompts(['La configuración seleccionada ya esta activa en el calendario.']);
		}
		if(!req.comments || req.comments.length < 5) return setModalPrompts(['Favor de ingresar comentarios completos sobre la solicitud de reembolsable.']);
		setModalPrompts([]);
		setLoading(true);
		API.createRefundableRequest(date.date_id, req.refundable_web, req.refundable_pdv, req.refundable_complete, req.comments).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			Toast.success('Se ha creado la solicitud de reembolsable y se le ha enviado los cambios solicitados a un administrador con acceso.');
			setRefundRequest({
				sent: true,
				refundable_web: req.refundable_web,
				refundable_pdv: req.refundable_pdv,
				refundable_complete: req.refundable_complete,
				comments: req.comments,
			});
			setRefundRequestModal(false);
		}).catch(err=>{
			return setModalPrompts(['Hubo un error inesperado creando la solicitud de reembolsable. (LCL-1)']);
		}).finally(()=>{
			setLoading(false);
		});
	}

	var sendRefundOptions = (setLoading: SetLoading)=>{
		var opts = {
			refundable_web: date.refundable_web,
			refundable_pdv: date.refundable_pdv,
			refundable_complete: date.refundable_complete,
		}
		if(!opts.refundable_web && !date.refundable_pdv){
			opts.refundable_complete = false;
		}

		setLoading(true);
		API.editDateRefundOptions(date.date_id, opts.refundable_web, opts.refundable_pdv, opts.refundable_complete).then(res=>{
			if(res.error) return Toast.error(res.message);
			Toast.success('Se ha cambiado la configuración de reembolso del calendario.');
		}).catch(err=>{
			return Toast.error('Hubo un error inesperado cambiando la configuración (LCL-2)');
		}).finally(()=>{
			setLoading(false);
		})
	}

	var deleteEventDate = (setLoading: SetLoading)=>{
		var confirm_text = props.event.event_name;
		if(deleteConfirm.trim() !== confirm_text) return Toast.error(`Favor de ingresar el texto de confirmación: "${confirm_text}"`);

		setLoading(true);
		API.deleteEventDate(date.date_id).then(res=>{
			if(res.error) return Toast.error(res.message);
			Toast.success('Se ha eliminado el calendario correctamente.');
			navigate(-1);
		}).catch(err=>{
			Toast.error('Hubo un error inesperado eliminado el calendario (LCL-2)');
		}).finally(()=>{
			setLoading(false);
			setShownModal(null);
			setDeleteConfirm(null);
		});
	}

	var onQueueChange = (val: boolean)=>{
		setSendingQueue(true);
		API.setDateQueue(date.date_id, val).then(res=>{
			if(res.error) return Toast.error(res.message);
			setDate({
				...date,
				queue_id: (res.data.queue_id || null)
			});
			Toast.success(`Se ha ${!val ? 'des' : ''}activado la fila de espera para este calendario`)
		}).catch(err=>{
			Toast.error('Hubo un error inesperado cambiando el estatus de la fila de espera. (LCL-1)');
		}).finally(()=>{
			setSendingQueue(false);
		})
	}

	var toggleAllPrices = (section_id: number)=>{
		return ()=>{
			var sp = [...shownSectionPrices];
			if(sp.indexOf(section_id)==-1){
				sp.push(section_id);
			}else{
				sp = sp.filter(a=>a!==section_id);
			}
			setShownSectionPrices(sp);
		}
	}

	var calculatePriceCommission = ()=>{
		if(!editingPrice.cost || editingPrice.cost <= 0) return Toast.error(`No se puede calcular el porcentaje de '${editingPrice.cost}'`);
		var com = (editingPrice.cost*parseFloat(pricePercentage))/100;
		editingPrice.commission = roundNumberV1(com,2);
		setPricePercentage(null);
		setPricePercentageModal(false);
	}

	var roundNumberV1 = (num: number, scale: number)=>{
		if(!("" + num).includes("e")){
			return +(Math.round(parseFloat(num + "e+" + scale)) + "e-" + scale);
		}else{
			var arr = ("" + num).split("e");
			var sig = ""
			if(+arr[1] + scale > 0){
				sig = "+";
			}
			var i = +arr[0] + "e" + sig + (+arr[1] + scale);
			var j = Math.round(parseFloat(i));
			var k = +(j + "e-" + scale);
			return k;
		}
	}

	var onPdvMethodCheckbox = (type_id: number, key: keyof EventDateData["pdv_payment_methods"][0], inverse?: boolean)=>{
		return (v: boolean)=>{
			var mt = [...date.pdv_payment_methods];
			var mx = mt.findIndex(a=>a.type_id===type_id);
			if(mx===-1) return;
			(mt[mx] as any)[key] = inverse ? !v : v;
			setDate(d=>({
				...d,
				pdv_payment_methods: mt
			}));
		}
	}

	var onPdvMethodChange = (type_id: number, key: keyof EventDateData["pdv_payment_methods"][0])=>{
		return (val: string)=>{
			var mt = [...date.pdv_payment_methods];
			var mx = mt.findIndex(a=>a.type_id===type_id);
			if(mx===-1) return;
			val = val.replace(/[^0-9.]/g, '');
			var v = !val || val.length==0 ? null : (parseFloat(val)<=0 || Number.isNaN(parseFloat(val)) ? null : val);

			(mt[mx][key] as any) = v;
			setDate(d=>({
				...d,
				pdv_payment_methods: mt
			}));
		}
	}

	var savePdvMethods = (setLoading: SetLoading)=>{
		setLoading(true);
		API.editDatePdvMethods(date.date_id, date.pdv_payment_methods.map(a=>({
			type_id: a.type_id,
			force_disable: !!a.force_disable,
			commission_percent: roundNumber(parseFloat(a.commission_percent)),
			commission_amount: a.commission_amount,
			replace_commission: !!a.replace_commission,
		}))).then(res=>{
			if(res.error) return Toast.error(res.message);
			return Toast.success(t('common.config_saved'))
		}).catch(err=>{
			return Toast.error(t('common.unexpected_code', { code: 'LCL-EVDT-SVPVM-1' }));
		}).finally(()=>{
			setLoading(false);
		})
	}

	var showRemoveSection = (section_id: number)=>{
		return ()=>{
			var sc = date.sections.find(a=>a.section_id===section_id);
			if(!sc) return;
			setSelectedSection(sc);
			setShownModal(ModalType.REMOVE_DATE_SECTION)
		}
	}

	var sendRemoveSection = (setLoading: SetLoading)=>{
		if(!selectedSection) return;
		setLoading(true);
		API.removeDateSection(date.date_id, selectedSection.section_id).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			setShownModal(null);
			setDate({
				...date,
				sections: date.sections.filter(a=>a.section_id!==selectedSection.section_id),
			});
			setSelectedSection(null);
			Toast.success('Se ha eliminado la sección del calendario');
		}).catch(err=>{
			setModalPrompts([t('common.unexpected_code', { code: 'LCL-DTVW-SNDRMSC-1' })]);
		}).finally(()=>{
			setLoading(false);
		})
	}

	if(!date) return <Header loading text="Cargando calendario" />
	var now = unix();
	var missing_sections = date.venue.sections.filter(a=>date.sections.findIndex(b=>b.section_id == a.section_id) == -1);
	var date_warnings = [];
	var active_payments = date.payment_methods.length > 0 ? date.payment_methods.filter(a=>isActive(a.date_start, a.date_end, true)).length : 0;
	var active_delivery = date.delivery.length > 0 ? date.delivery.filter(a=>isActive(a.date_start, a.date_end, true)).length : 0;
	var hasEditDatesAccess = hasAccess(UserAccess.DATES.CHANGE_START_END_DATES);
	if(active_payments <= 0){
		date_warnings.push('No hay métodos de pago activos.');
	}
	if(active_delivery <= 0){
		date_warnings.push('No hay formas de entrega activas.');
	}

	var onDateFormChange = bindFormChange(date, setDate);
	var onSectionFormChange = bindFormChange(selectedSection, setSelectedSection);
	var onPaymentFormChange = bindFormChange(selectedPayment, setSelectedPayment);
	var onDeliveryFromChange = bindFormChange(selectedDelivery, setSelectedDelivery);
	var onPriceFormChange = bindFormChange(editingPrice, setEditingPrice);
	var onRequestFormChange = bindFormChange(refundRequest, setRefundRequest);
	var now = moment().unix();

	return <div>
		{date_warnings.length > 0 && (
			<Message type="warning" text="El calendario tiene algunos problemas" list={date_warnings} style={{ maxWidth: 500, margin: 'auto', marginBottom: 15 }} />
		)}
		<Groupper title="Editar calendario" titleRight={`ID: ${date.date_id}`} style={{ maxWidth: 700, margin: 'auto' }} actions={(
			<Button text="Guardar" color="black" onClick={editDate} />
		)}>
			<Input calendar={{ date: fromUnix(date.date).toJSDate(), mode: 'datetime', onSelected: v=>onDateFormChange('date')(Math.floor(v.getTime()/1000)) }} inputStyle={{ fontSize: 20, textAlign: 'center', fontWeight: 'bold' }} label="Fecha" />
			<Field label="Recinto" >
				<Input value={`${date.venue_name}, ${date.city}`} readonly buttons={(
					<Link className="fr button" to={`/venues/${date.venue_id}`} target="_blank">Ver recinto</Link>
				)} />
			</Field>
			{hasAccess(UserAccess.DATES.CHANGE_STATUS) && (
				<Field amount={3} label="Estatus">
					<Field style={{ marginTop: 5 }}>
						<Checkbox label="Publicado" checked={!!date.published} onChange={onDateFormChange('published')} />
					</Field>
					<Field style={{ marginTop: 5 }}>
						<Checkbox label="Activo Web" checked={!!date.active_web} onChange={onDateFormChange('active_web')} />
					</Field>
					<Field style={{ marginTop: 5 }}>
						<Checkbox label="Activo PDV" checked={!!date.active_pdv} onChange={onDateFormChange('active_pdv')} />
					</Field>
				</Field>
			)}
			{(!date.active_web || !date.active_pdv) && (
				// <Field label=>
					<Dropdown
						value={date.status_id}
						label={"Estado no venta"}
						placeholder="Cambair estatus"
						loading={!eventDateStatus}
						onValueChange={onDateFormChange('status_id')}
						items={eventDateStatus ? eventDateStatus.filter(a=>a.status_id !== 1).map(a=>({
							value: a.status_id,
							text: a.status_name,
							meta: `ID: ${a.status_id}`,
						})) : []}
					/>
				// </Field>
			)}
			<Message list={datePrompts} type="error" />
		</Groupper>
		{/*===============================
			SECTIONS
			=============================== */}
		<Groupper style={{ maxWidth: 700, margin: '15px auto' }} fitted title="Secciones">
			{hasAccess(UserAccess.DATES.EDIT_SECTIONS) && (
				<Toolbar stretch={false} fitted style={{ marginBottom: 0, borderBottom: 0 }} >
					<Toolbar.Item iconName='plus-circle' text='Agregar' color='black' className={missing_sections.length>0 ? '' : 'disabled'} onClick={bindClick(setShownModal, ModalType.SECTION_ADD)} />
					<Toolbar.Item iconName='sort' text='Ordenar' color='black' className={date.sections.length>0 ? '' : 'disabled'} onClick={openModalSortSections} />
					<Toolbar.Item iconName='clipboard-list' text='Estatus' color='black' className={date.sections.length>0 ? '' : 'disabled'} onClick={bindClick(setShownModal, ModalType.SECTION_STATUS)} />
				</Toolbar>
			)}
			{loadingSections ? (
				<Header loading text="Cargando secciones" size="small" />
			) : <>
				{date.sections.length == 0 && (
					<table className="fr table">
						<tbody>
							<tr>
								<td className="empty">
									{missing_sections.length==0 && date.sections.length==0 ? (
										<Message>
											El calendario no tiene secciones agregadas, y el recinto no tiene secciones disponibles.
											<br />
											<Button text="Editar recinto" color="black" style={{ marginTop: 10 }} as={Link} to={`/venues/${date.venue_id}`} />
										</Message>
									) : 'No hay secciones agregadas'}
								</td>
							</tr>
						</tbody>
					</table>
				)}
				{date.sections.map(a=>{
					var active = a.active && a.prices.length > 0 && a.published;
					var date_active = isActive(a.date_start, a.date_end);
					var showing_all = shownSectionPrices.indexOf(a.section_id)>-1;
					var shown_prices = a.prices.filter(pr=>showing_all || ((pr.published_web || pr.published_pdv) && (isActive(pr.date_start, pr.date_end) || isActive(pr.date_start_pdv, pr.date_end_pdv, false))));
					var more_to_show = shown_prices.length<a.prices.length;

					return (
						<table className={classNames('fr table', {
							selectable: hasAccess(UserAccess.DATES.EDIT_PRICES),
						})} key={`date-section-${a.section_id}`}>
							<thead>
								<tr id="sectionRow-<%= i.section_id %>">
									<th colSpan={6} className="title">
										<div className="fr flex">
											<div className="grow">
												<div className={`fr ${active ? 'green' : 'red'} label`} style={{ marginRight: 10, display: 'flex', alignItems: 'center' }}>
													<Icon name={active ? 'check' : 'times'} style={{ marginRight: 0, fontSize: 16 }} />
													{!active ? (
														<Icon name={classNames({
															'dollar sign': a.prices.length == 0,
															calendar: a.prices.length > 0 && !date_active,
															'eye slash': date_active && a.prices.length > 0 && !a.published
														}) as any} style={{ marginRight: 0, fontSize: 10 }} />
													) : null}
												</div>
												<div>
													{a.section_name}
													<div className="meta" style={{ fontSize: 12, textTransform: 'none', lineHeight: '12px' }}>
														{a.numbered ? 'Numerada' : <>
															Aforo: {' '}
															{a.infinite ? <Icon name="infinity" style={{ marginLeft: 5, lineHeight: '12px' }} /> : addCommas(a.date_ticket_count || a.ticket_count, false)}
															{(!!a.date_ticket_count && a.date_ticket_count!=a.ticket_count) && (
																<Icon name="pen" style={{ marginLeft: 5 }} />
															)}
														</>}
													</div>
												</div>
											</div>
											<Button iconName="wrench" size="tiny" text="Opciones" menu={[
												{ text: 'Editar', iconName: 'pen', onClick: editSection(a.section_id) },
												{ text: 'Editar aforo', iconName: 'pen', onClick: editSectionTicketCount(a.section_id), disabled: a.infinite || !hasAccess(UserAccess.DATES.EDIT_SECTION_TICKET_COUNT), if: !a.numbered },
												{ text: 'Agregar precio', iconName: 'plus', onClick: addSectionPrice(a.section_id), disabled: !hasAccess(UserAccess.DATES.EDIT_PRICES) },
												{ text: showing_all ? 'Esconder inactivos' : 'Mostrar inactivos', disabled: !more_to_show, iconName: showing_all ? 'eye-slash' : 'eye', onClick: more_to_show ? toggleAllPrices(a.section_id) : null },
												{ text: 'Mapa', iconName: 'map', onClick: editSeatmap(a.section_id), disabled: !hasAccess(UserAccess.DATES.EDIT_PRICES), if: !!a.numbered },
												{ text: 'Editar numeración', iconName: 'hashtag', disabled: !hasAccess(UserAccess.VENUES.EDIT_VENUE_SEATS), as: Link, to: `/venues/${a.venue_id}/sections/${a.section_id}/seatmap/date/${date.date_id}`, if: !!a.numbered },
												{ text: 'Bloqueo', iconName: 'bookmark', onClick: openHoldModal(a.section_id), disabled: !hasAccess([UserAccess.DATES.ADD_SECTION_HOLD, UserAccess.DATES.DELETE_SECTION_HOLD], true), if: !a.numbered },
												{ text: 'Ordenar precios', iconName: 'sort', onClick: openModalSortPrice(a.section_id), disabled: a.prices.length<=1 || !hasAccess(UserAccess.DATES.EDIT_SECTIONS) },
												{ text: 'Eliminar', iconName: 'ban', onClick: showRemoveSection(a.section_id), disabled: !hasAccess(UserAccess.DATES.REMOVE_DATE_SECTION) },
											]} />
											{/* <Dropdown icon={null} direction="left" trigger={(
												<Button iconName="wrench" size="tiny" text="Opciones" />
											)}>
												<Dropdown.Menu>
													<Dropdown.Item text="Editar" icon="pencil" onClick={editSection(a.section_id)} />
													{!a.numbered && (
														<Dropdown.Item text="Editar aforo" icon="edit" onClick={editSectionTicketCount(a.section_id)} disabled={a.infinite || !hasAccess(UserAccess.DATES.EDIT_SECTION_TICKET_COUNT)} />
													)}
													<Dropdown.Item icon='plus' text='Agregar precio' onClick={addSectionPrice(a.section_id)} disabled={!hasAccess(UserAccess.DATES.EDIT_PRICES)} />
													<Dropdown.Item disabled={!more_to_show} icon={showing_all ? 'eye slash' : 'eye'} text={showing_all ? 'Esconder inactivos' : 'Mostrar inactivos'} onClick={more_to_show ? toggleAllPrices(a.section_id) : null} />
													{a.numbered ? <>
														<Dropdown.Item text="Mapa" icon="map" onClick={editSeatmap(a.section_id)} disabled={!hasAccess(UserAccess.DATES.CHANGE_DATE_SEAT_STATUS)} />
														<Dropdown.Item text="Editar numeración" icon="hashtag" disabled={!hasAccess(UserAccess.VENUES.EDIT_VENUE_SEATS)} as={Link} to={`/venues/${a.venue_id}/sections/${a.section_id}/seatmap/date/${date.date_id}`} />
													</> : (
														<Dropdown.Item text="Bloqueo" icon="bookmark" onClick={openHoldModal(a.section_id)} disabled={!hasAccess([UserAccess.DATES.ADD_SECTION_HOLD, UserAccess.DATES.DELETE_SECTION_HOLD], true)} />
													)}
													<Dropdown.Item disabled={a.prices.length<=1 || !hasAccess(UserAccess.DATES.EDIT_SECTIONS)} text='Ordenar precios' icon='sort' onClick={a.prices.length>0 ? openModalSortPrice(a.section_id) : null} />
													<Dropdown.Item disabled={!hasAccess(UserAccess.DATES.REMOVE_DATE_SECTION)} text='Eliminar' icon='ban' onClick={showRemoveSection(a.section_id)} />
												</Dropdown.Menu>
											</Dropdown> */}
										</div>
									</th>
								</tr>
								<tr>
									<th className="collapsing" style={{ textAlign: 'center' }}>ID</th>
									<th>Nombre</th>
									<th className="collapsing" style={{ textAlign: 'center' }}>Precio</th>
									<th className="collapsing" style={{ textAlign: 'center' }}>Comisión</th>
									<th className="collapsing">PDV</th>
									<th className="collapsing">Web</th>
								</tr>
							</thead>
							<tbody>
								{shown_prices.length == 0 ? (
									<tr className="noselect">
										<td className="empty" colSpan={1000}>
											No hay precios en esta sección
											{shown_prices.length!==a.prices.length && <>
												<br />
												Hay <b>{a.prices.length-shown_prices.length}</b> precio{a.prices.length-shown_prices.length==1 ? '' : 's'} no activo{a.prices.length-shown_prices.length==1 ? '' : 's'}
											</>}
										</td>
									</tr>
								) : null}
								{shown_prices.map(p=>{
									const active_price_pdv = p.published_pdv && p.available;
									const active_price_web = p.published_web && p.available;
									return (<tr key={`section-price-${p.price_id}`} onClick={editPrice(a.section_id, p.price_id)}>
										<td>{p.price_id}</td>
										<td>{p.price_name}</td>
										<td style={{ textAlign: 'center' }}>${addCommas(p.cost)}</td>
										<td style={{ textAlign: 'center' }}>${addCommas(p.commission, true, true)}</td>
										<td style={{ textAlign: 'center' }}>
											<Icon name={active_price_pdv ? 'check' : 'remove'} color={active_price_pdv ? 'green' : 'black'} />
										</td>
										<td style={{ textAlign: 'center' }}>
											<Icon name={active_price_web ? 'check' : 'remove'} color={active_price_web ? 'green' : 'black'} />
										</td>
									</tr>)
								})}
							</tbody>
						</table>
					)
				})}
			</>}
		</Groupper>
		{hasAccess(UserAccess.DATES.EDIT_SECTIONS) && (
			<Modal size="tiny" open={!!selectedSection && shownModal === ModalType.EDIT_SECTION} onClose={bindClick(setSelectedSection)}>
				<Modal.Header>{selectedSection && selectedSection.section_id ? 'Editar' : 'Agregar'} sección</Modal.Header>
				{selectedSection ? <Modal.Content>
					<Field amount={2}>
						<Input label="Sección" value={selectedSection.section_name} readonly />
						<Input label="ID Sección" value={selectedSection.section_id?.toString()} readonly />
					</Field>
					<Field>
						<Checkbox checked={selectedSection.published} onChange={onSectionFormChange('published')} label={'Publicada'} />
					</Field>
					<Field amount={2}>
						<Input 
							label="Fecha inicio" 
							calendar={{ 
								date: selectedSection.date_start ? fromUnix(selectedSection.date_start).toJSDate() : null, 
								mode: 'datetime',
								onSelected: v=>onSectionFormChange('date_start')(v.getTime()/1000)
							}} 
							type={(selectedSection.date_start===null || now > selectedSection.date_start) ? 'normal' : 'warning'} 
							buttons={(
								<Button icon iconName="times" onClick={()=>onSectionFormChange('date_start')(null)} />
							)} 
						/>
						<Input 
							label="Fecha inicio" 
							calendar={{ 
								date: selectedSection.date_end ? fromUnix(selectedSection.date_end).toJSDate() : null, 
								mode: 'datetime',
								onSelected: v=>onSectionFormChange('date_end')(v.getTime()/1000),
							}} 
							type={(selectedSection.date_end===null || now < selectedSection.date_end) ? 'normal' : 'warning'} 
							buttons={(
								<Button icon iconName="times" onClick={()=>onSectionFormChange('date_end')(null)} />
							)} 
						/>
					</Field>
					<Message list={modalPrompts} type="error" style={{ marginTop: 10 }} />
				</Modal.Content> : null}
				<Modal.Actions>
					<Button text="Regresar" basic onClick={()=>setSelectedSection(null)} />
					<Button text="Guardar" color="black" onClick={saveSection} />
				</Modal.Actions>
			</Modal>
		)}
		{hasAccess(UserAccess.DATES.EDIT_PRICES) && (
			<Modal open={!!editingPrice} onClose={bindClick(setEditingPrice)} size="tiny">
				<Modal.Header>{editingPrice && editingPrice.price_id ? 'Editar' : 'Agregar'} precio</Modal.Header>
				{editingPrice ? (
					<Modal.Content>
						<Field amount={editingPrice.price_id ? 2 : 1}>
							{editingPrice.price_id ? <Input label="ID Precio" value={editingPrice.price_id?.toString()} readonly /> : null}
							<Input label="Nombre" value={editingPrice.price_name} onChange={onPriceFormChange('price_name')} />
						</Field>
						<Field amount={2}>
							<Input label="Precio" value={editingPrice.cost?.toString()} onChange={onPriceFormChange('cost')} />
							<Input 
								label="Comisión"
								value={editingPrice.commission?.toString()} 
								onChange={onPriceFormChange('commission')} 
								buttons={(
									<Button iconName="percentage" icon onClick={()=>setPricePercentageModal(true)} />
								)} 
							/>
						</Field>
						<Message style={{ margin: '0 auto 10px auto', maxWidth: 300 }}>
							<Stat label={'Precio final'} value={'$'+addCommas((parseFloat(editingPrice.cost as any) || 0)+(parseFloat(editingPrice.commission as any) || 0), true, true)} style={{ padding: 0 }} />
						</Message>
						<Field amount={3}>
							<Input label="Minimo boletos" value={editingPrice.min_tickets?.toString()} onChange={onPriceFormChange('min_tickets')} />
							<Input label="Máximo boletos" value={editingPrice.max_tickets?.toString()} onChange={onPriceFormChange('max_tickets')} />
							<Input label="Múltiplo" value={editingPrice.multiple?.toString()} onChange={onPriceFormChange('multiple')} />
						</Field>
						
						<Field amount={2}>
							<Input 
								label="Fecha inicio" 
								calendar={{ 
									date: editingPrice.date_start ? fromUnix(editingPrice.date_start).toJSDate() : null,
									mode: 'datetime',
									onSelected: v=>onPriceFormChange('date_start')(v.getTime()/1000),
								}} 
								type={(!editingPrice.price_id || (!editingPrice.date_start || now > editingPrice.date_start)) ? 'normal' : 'warning'} 
								buttons={(
									<Button icon iconName="times" onClick={()=>onPriceFormChange('date_start')(null)} />
								)} 
							/>
							<Input
								label="Fecha fin"
								calendar={{
									date: editingPrice.date_end ? fromUnix(editingPrice.date_end).toJSDate() : null,
									mode: 'datetime',
									onSelected: v=>onPriceFormChange('date_end')(v.getTime()/1000)
								}}
								type={(!editingPrice.price_id || (!editingPrice.date_end || now < editingPrice.date_end)) ? 'normal' : 'warning'}
								buttons={(
									<Button icon iconName="times" onClick={()=>onPriceFormChange('date_end')(null)} />
								)} 
							/>
						</Field>
						<Field amount={2}>
							<Input 
								label="Fecha inicio PDV"
								placeholder={editingPrice.date_start ? fromUnix(editingPrice.date_start).toFormat('dd/MM/yy HH:mm') : 'Fecha inicio PDV'}
								calendar={{
									date: editingPrice.date_start_pdv ? fromUnix(editingPrice.date_start_pdv).toJSDate() : null,
									mode: 'datetime',
									onSelected: v=>onPriceFormChange('date_start_pdv')(v.getTime()/1000),
								}}
								type={(!editingPrice.price_id || (!editingPrice.date_start_pdv || now > editingPrice.date_start_pdv)) ? 'normal' : 'warning'}
								buttons={(
									<Button icon iconName="times" onClick={()=>onPriceFormChange('date_start_pdv')(null)} />
								)} 
							/>
							<Input
								label="Fecha fin PDV"
								placeholder={editingPrice.date_end ? fromUnix(editingPrice.date_end).toFormat('dd/MM/yy HH:mm') : 'Fecha inicio PDV'}
								calendar={{
									date: editingPrice.date_end_pdv ? fromUnix(editingPrice.date_end_pdv).toJSDate() : null,
									mode: 'datetime',
									onSelected: v=>onPriceFormChange('date_end_pdv')(v.getTime()/1000)
								}}
								type={(!editingPrice.price_id || (!editingPrice.date_end_pdv || now < editingPrice.date_end_pdv)) ? 'normal' : 'warning'}
								buttons={(
									<Button icon iconName="times" onClick={()=>onPriceFormChange('date_end_pdv')(null)} />
								)} 
							/>
						</Field>
						<Field label="Dias de la Semana" comment={getDaysAvailable(editingPrice.days_available)}>
							<SegmentControl
								style={{ gap: 0, padding: 0 }}
								values={['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa']}
								selected={editingPrice.days_available}
								onSelected={onPriceFormChange('days_available')}
							/>
						</Field>
						<Field style={{ marginTop: 15 }} label="Publicación">
							<Checkbox label={'Publicar PDV'} onChange={onPriceFormChange('published_pdv')} checked={!!editingPrice.published_pdv} style={{ marginBottom: 5, marginTop: 5 }} />
							<Checkbox label={'Publicar WEB'} onChange={onPriceFormChange('published_web')} checked={!!editingPrice.published_web} />
						</Field>
						<Field label="Solo en recinto" comment="El precio solo aparecerá en el recinto del calendario">
							<Checkbox label={"Solo en recinto"} onChange={onPriceFormChange('venue_only')} checked={!!editingPrice.venue_only} />
						</Field>
						<Field label="Restringir en PDV" comment="Solo usuarios con permiso podrán vender boletos con este precio">
							<Checkbox label={"Restringir en PDV"} onChange={onPriceFormChange('restricted')} checked={!!editingPrice.restricted} />
						</Field>
						<Field label="Solicitar descripción" >
							<Checkbox 
								label={"Se le pedirá descripción al taquillero en el PDV"} 
								onChange={onPriceFormChange('needs_comment')} 
								checked={!!editingPrice.needs_comment} 
							/>
						</Field>
						<Field label="Limite de boletos" >
							<Checkbox label={"Limitar la cantidad de boletos vendidos con este precio"} onChange={(val)=>setEditingPrice({...editingPrice, ticket_limit: val ? 0 : null })} checked={![null, undefined].includes(editingPrice.ticket_limit)} />
						</Field>
						{[null, undefined].includes(editingPrice.ticket_limit) ? null : (
							<Input
								placeholder="Limite de boletos"
								value={editingPrice.ticket_limit === 0 ? '' : editingPrice.ticket_limit?.toString()} 
								onChange={onPriceFormChange('ticket_limit')}
							/>
						)}
						<Message list={modalPrompts} type="error" />
					</Modal.Content>
				) : null}
				<Modal.Actions>
					<Button text="Regresar" basic onClick={bindClick(setEditingPrice)} />
					<Button text="Guardar" color="black" onClick={savePriceEdit} />
				</Modal.Actions>
			</Modal>
		)}
		<Modal size="mini" open={pricePercentageModal} onClose={()=>setPricePercentageModal(false)}>
			<Modal.Header>Porcentaje</Modal.Header>
			<Modal.Content>
				<Field label="Ingrese el porcentaje" >
					<Input inputType="number" iconName='percentage' value={pricePercentage} onChange={setPricePercentage} />
				</Field>
			</Modal.Content>
			<Modal.Actions>
				<Button text="Regresar" basic onClick={()=>setPricePercentageModal(false)} />
				<Button text="Calcular" color='black' onClick={calculatePriceCommission} />
			</Modal.Actions>
		</Modal>
		{/*===============================
			PAYMENT METHODS
			=============================== */}
		<Groupper title="Métodos de pago" fitted style={{ maxWidth: 700, margin: '15px auto' }} actions={(
			<Button text={t('common.save')} color="black" onClick={savePdvMethods} />
		)}>
			{hasAccess(UserAccess.DATES.EDIT_PAYMENT_METHODS) && (
				<Toolbar stretch={false} fitted style={{ marginBottom: 0, borderBottom: 0 }}>
					<Toolbar.Dropdown text="Agregar" iconName="circle-plus"
						items={paymentMethods ? paymentMethods.map(a=>({
							text: a.method_name_internal,
							onClick: addPaymentMethod(a.method_id)
						})) : []}
					/>
				</Toolbar>
			)}
			<Table selectable={hasAccess(UserAccess.DATES.EDIT_PAYMENT_METHODS) && date.payment_methods.length>0}>
				<Table.Head
					data={[['ID', 'Método', 'Comisión', 'Forzar', 'Activo']]}
					centeredIndexes={[2, 3, 4]}
				/>
				<Table.Body>
					{date.payment_methods.length==0 && (
						<Table.Cell empty row colSpan={100} value={'No hay métodos de pago agregados'} />
					)}
					{date.payment_methods.sort((a, b)=>a.payment_method - b.payment_method).map(a=>(
						<Table.Row
							collapsingIndexes={[0, 2,3,4]}
							centeredIndexes={[2,3,4]}
							onClick={addPaymentMethod(a.payment_method)}
							key={a.payment_method}
							data={[
								a.payment_method,
								a.method_name_internal,
								((a.date_commission_amount >= 0 && a.date_commission_amount !== null) || (a.date_commission_percent >= 0 && a.date_commission_percent !== null)) ? <>
									<Icon name="pencil" />
									{formatCommission(a.date_commission_percent * 100, a.date_commission_amount)}
								</> : ((a.commission_amount >= 0 && a.commission_amount !== null) || (a.commission_percent >= 0 && a.commission_percent !== null)) ? (
									formatCommission(a.commission_percent * 100, a.commission_amount)
								) : (
									<Icon name="minus" color="grey" />
								),
								<Icon name={a.force_show ? 'check' : 'minus'} color={a.force_show ? 'black' : 'grey'} style={{ marginRight: 0 }} />,
								<Icon name={isActive(a.date_start, a.date_end) ? 'check' : 'minus'} color={isActive(a.date_start, a.date_end) ? 'green' : 'grey'} style={{ marginRight: 0 }} />,
							]}
						/>
					))}
				</Table.Body>
			</Table>
			<Table striped celled style={{ borderBottomWidth: 1, borderBottomColor: 'rgba(0,0,0,0.1)', borderBottomStyle: 'solid' }}>
				<Table.Head
					title="Pago en PDV"
					titleSize="small"
					data={[['Método', 'Es CxS', 'Porcentaje', 'Cantidad', 'Comisión']]} 
					centeredIndexes={[1, 2, 3, 4]}
				/>
				<Table.Body>
					{date.pdv_payment_methods.map(a=>{
						var has_commission = !!a.commission_amount || !!a.commission_percent;
						return <Table.Row key={`PMTH-${a.type_id}`} centeredIndexes={[1, 2, 3, 4]}>
							{/* <Table.Cell collapsing>
								<Checkbox checked={!a.force_disable} onChange={onPdvMethodDisable(a.type_id)} />
							</Table.Cell> */}
							<Table.Cell>
								{t(`payment_method_type.type_${a.type_id}`)} <br />
								{!!a.replace_commission && !a.force_disable && !!has_commission && (
									<span style={{ color: 'gray', fontSize: 12, lineHeight: '11px', display: 'block' }}>Se reemplazará el cargo por servicio por esta comisión</span>
								)}
							</Table.Cell>
							<Table.Cell collapsing>
								<Checkbox checked={a.replace_commission} onChange={onPdvMethodCheckbox(a.type_id, 'replace_commission')} />
							</Table.Cell>
							<Table.Cell collapsing>
								<Input onChange={onPdvMethodChange(a.type_id, 'commission_percent')} placeholder='%' value={(a.commission_percent || '').toString()} style={{ marginBottom: 0, width: 60, opacity: a.force_disable ? 0.4 : 1 }} inputStyle={{ textAlign: 'center'}} />
							</Table.Cell>
							<Table.Cell collapsing>
								<Input onChange={onPdvMethodChange(a.type_id, 'commission_amount')} placeholder='$' value={(a.commission_amount || '').toString()} style={{ marginBottom: 0, width: 60, opacity: a.force_disable ? 0.4 : 1 }} inputStyle={{ textAlign: 'center'}} />
							</Table.Cell>
							<Table.Cell collapsing centered style={{ fontWeight: has_commission ? 'bold' : 'normal', color: has_commission ? 'black' : 'gray', minWidth: 120 }}>
								{a.force_disable ? (
									<Icon name='minus' color='gray' />
								) : (
									formatCommission((a.commission_percent ? parseFloat(a.commission_percent) : 0), (a.commission_amount || 0))
								)}
							</Table.Cell>
						</Table.Row>
					})}
				</Table.Body>
			</Table>
		</Groupper>
		{hasAccess(UserAccess.DATES.EDIT_PAYMENT_METHODS) && (
			<Modal size={'tiny'} open={addPaymentModal} onClose={()=>setAddPaymentModal(false)}>
				<Modal.Header>Método de pago</Modal.Header>
				{selectedPayment && (
					<Modal.Content>
						<Input label="Método de pago" value={selectedPayment.method_name} readonly />
						<Input
							fluid
							label="Fecha inicio" 
							calendar={{ 
								date: selectedPayment.date_start ? fromUnix(selectedPayment.date_start).toJSDate() : null,
								mode: 'datetime',
								onSelected: v=>onPaymentFormChange('date_start')(v.getTime()/1000)
							}} 
							type={(!selectedPayment.date_start || now > selectedPayment.date_start) ? 'normal' : 'warning'} 
							buttons={(
								<Button icon iconName="times" onClick={()=>onPaymentFormChange('date_start')(null)} />
							)} 
						/>
						<Input
							label="Fecha fin" 
							calendar={{
								date: selectedPayment.date_end ? fromUnix(selectedPayment.date_end).toJSDate() : null,
								mode: 'datetime',
								onSelected: v=>onPaymentFormChange('date_end')(v.getTime()/1000),
							}} 
							type={(!selectedPayment.date_end || now<selectedPayment.date_end) ? 'normal' : 'warning'} 
							buttons={(
								<Button icon iconName="times" onClick={()=>onPaymentFormChange('date_end')(null)} />
							)} 
						/>
						<Field label="Forzar método de pago">
							<Checkbox label="Mostrar método de pago sin importar el día de la semana" checked={!!selectedPayment.force} onChange={onPaymentFormChange('force')} />
						</Field>
						<Field label="Comisión calendario">
							<Checkbox label="Cambiar la comision solo para este calendario" checked={!!selectedPayment.change_commission} onChange={onPaymentFormChange('change_commission')} />
						</Field>
						{selectedPayment.change_commission && <>
							<Field amount={2}>
								<Input label="Comision cantidad" value={(selectedPayment.commission_amount || '').toString()} onChange={onPaymentFormChange('commission_amount')} inputType="number" />
								<Input label="Comision porcentaje" value={(selectedPayment.commission_percent || '').toString()} onChange={onPaymentFormChange('commission_percent')} inputType="number" />
							</Field>
						</>}
						<Message centered type="info" style={{ marginBottom: 5 }}>
							Se agregará {formatCommission(selectedPayment.change_commission ? selectedPayment.commission_percent : selectedPayment.original_commission_percent, selectedPayment.change_commission ? selectedPayment.commission_amount : selectedPayment.original_commission_amount)}
						</Message>
						<Message list={modalPrompts} type="error" />
						{selectedPayment.edit && (
							<Button basic text="Eliminar" color="red" style={{ width: 200, margin: 'auto', display: 'block', marginBottom: -5 }} onClick={()=>setConfirmPaymentModal(true)} />
						)}
					</Modal.Content>
				)}
				<Modal.Actions>
					<Button text="Regresar" basic onClick={()=>setAddPaymentModal(false)} />
					<Button text="Guardar" color="black" onClick={savePaymentMethod} />
				</Modal.Actions>
			</Modal>
		)}
		<Modal size="mini" open={confirmPaymentModal} onClose={()=>setConfirmPaymentModal(false)}>
			<Modal.Header>Eliminar método de pago</Modal.Header>
			{selectedPayment && (
				<Modal.Content>
					<Header size="small" text="¿Eliminar método de pago?" subtext={selectedPayment.method_name} />
				</Modal.Content>
			)}
			<Modal.Actions>
				<Button text="Regresar" basic onClick={()=>setConfirmPaymentModal(false)} />
				<Button text="Eliminar" color='red' onClick={removePaymentMethod} />
			</Modal.Actions>
		</Modal>

		{/*===============================
			DELIVERY METHODS
			=============================== */}
		<Groupper title="Formas de entrega" fitted style={{ margin: '15px auto', maxWidth: 700 }}>
			{hasAccess(UserAccess.DATES.EDIT_DELIVERY_METHODS) && (
				<Toolbar stretch={false} fitted style={{ marginBottom: 0, borderBottom: 0 }}>
					<Toolbar.Item text="Agregar" iconName="circle-plus" onClick={bindClick(setShownModal, ModalType.DELIVERY_METHODS)} />
				</Toolbar>
			)}
			<Table selectable={hasAccess(UserAccess.DATES.EDIT_DELIVERY_METHODS) && date.delivery.length>0}>
				<Table.Head data={[['ID', 'Método', 'Costo', 'Domicilio', 'Activo']]} collapsingIndexes={[0, 2, 3, 4]} />
				<Table.Body>
					{date.delivery.length==0 && (
						<Table.Cell empty row colSpan={100} value={'No hay formas de envío agregadas'} />
					)}
					{date.delivery.map(a=>{
						var active = isActive(a.date_start, a.date_end, true);
						return <Table.Row
							collapsingIndexes={[0, 2, 3, 4]}
							centeredIndexes={[2,3,4]}
							onClick={addDeliveryMethod(a)}
							key={`DLRW-${a.delivery_id}`}
							data={[
								a.delivery_id,
								a.method_name,
								`$${addCommas(a.delivery_cost)}`,
								<Icon name={a.needs_location ? 'check' : 'minus'} color={a.needs_location ? 'black' : 'grey'} style={{ marginRight: 0 }} />,
								<Icon name={active ? 'check' : 'remove'} color={active ? 'green' : 'grey'} style={{ marginRight: 0 }} />,
							]}
						/>
					})}
				</Table.Body>
			</Table>
		</Groupper>
		{hasAccess(UserAccess.DATES.EDIT_DELIVERY_METHODS) && (
			<SearchDeliveryModal
				open={shownModal===ModalType.DELIVERY_METHODS}
				onClose={bindClick(setShownModal)}
				onSelected={m=>{
					setShownModal(null);
					addDeliveryMethod(m)();
				}}
			/>
		)}
		{hasAccess(UserAccess.DATES.EDIT_DELIVERY_METHODS) && (
			<Modal open={addDeliveryModal} onClose={()=>setAddDeliveryModal(false)} size="tiny">
				<Modal.Header>Forma de entrega</Modal.Header>
				{selectedDelivery && <Modal.Content>
					<Input label="Forma de entrega" value={selectedDelivery.method_name} readonly />
					<Input 
						label="Fecha inicio"
						calendar={{ 
							date: selectedDelivery.date_start ? fromUnix(selectedDelivery.date_start).toJSDate() : null,
							mode: 'datetime',
							onSelected: v=>onDeliveryFromChange('date_start')(v.getTime()/1000),
						}} 
						buttons={(
							<Button icon iconName="times" onClick={()=>onDeliveryFromChange('date_start')(null)} />
						)} 
					/>
					<Input 
						label="Fecha fin"
						calendar={{ 
							date: selectedDelivery.date_end ? fromUnix(selectedDelivery.date_end).toJSDate() : null,
							mode: 'datetime',
							onSelected: v=>onDeliveryFromChange('date_end')(v.getTime()/1000),
						}} 
						buttons={(
							<Button icon iconName="times" onClick={()=>onDeliveryFromChange('date_end')(null)} />
						)} 
					/>
					<Input label="Costo" value={selectedDelivery.delivery_cost?.toString()} onChange={onDeliveryFromChange('delivery_cost')} />
					{selectedDelivery.edit && (
						<Button basic text="Eliminar" color="red" style={{ width: 200, margin: 'auto', display: 'block' }} onClick={bindClick(setConfirmDeliveryModal, true)} />
					)}
					<Message list={modalPrompts} type="error" style={{ marginTop: 10 }} />
				</Modal.Content>}
				<Modal.Actions>
					<Button text="Regresar" basic onClick={bindClick(setAddDeliveryModal, false)} />
					<Button text="Guardar" color="black" onClick={saveDeliveryMethod} />
				</Modal.Actions>
			</Modal>
		)}
		<Modal size="mini" open={confirmDeliveryModal} onClose={bindClick(setConfirmDeliveryModal, false)}>
			<Modal.Header>Eliminar método de pago</Modal.Header>
			{selectedDelivery && (
				<Modal.Content>
					<Header size="small" text="¿Eliminar forma de entrega?" subtext={selectedDelivery.method_name} />
				</Modal.Content>
			)}
			<Modal.Actions>
				<Button text="Regresar" basic onClick={bindClick(setConfirmDeliveryModal, false)} />
				<Button text="Eliminar" color='red' onClick={removeDelivery} />
			</Modal.Actions>
		</Modal>

		<Groupper title="Fechas" style={{ maxWidth: 700, margin: '15px auto' }} actions={(
			(hasEditDatesAccess && <Button text="Guardar" color="black" onClick={saveDateDates} />)
		)}>
			<Field amount={2}>
				<Input 
					label="Fecha inicio WEB" 
					calendar={{ 
						date: fromUnix(date.date_web_start).toJSDate(),
						mode: 'datetime',
						onSelected: v=>onDateFormChange('date_web_start')(v.getTime()/1000)
					}} 
					type={date.date_web_start > now ? 'warning' : 'normal'} 
					readonly={!hasEditDatesAccess} 
				/>
				<Input 
					label="Fecha fin WEB" 
					calendar={{ 
						date: fromUnix(date.date_web_end).toJSDate(),
						mode: 'datetime',
						onSelected: v=>onDateFormChange('date_web_end')(v.getTime()/1000)
					}} 
					type={date.date_web_end < now ? 'warning' : 'normal'} 
					readonly={!hasEditDatesAccess} 
				/>
			</Field>
			<Field amount={2}>
				<Input 
					label="Fecha inicio PDV" 
					calendar={{ 
						date: fromUnix(date.date_pdv_start).toJSDate(),
						mode: 'datetime',
						onSelected: v=>onDateFormChange('date_pdv_start')(v.getTime()/1000)
					}} 
					type={date.date_pdv_start > now ? 'warning' : 'normal'} 
					readonly={!hasEditDatesAccess} 
				/>
				<Input 
					label="Fecha fin PDV" 
					calendar={{ 
						date: fromUnix(date.date_pdv_end).toJSDate(),
						mode: 'datetime',
						onSelected: v=>onDateFormChange('date_pdv_end')(v.getTime()/1000)
					}} 
					type={date.date_pdv_end < now ? 'warning' : 'normal'} 
					readonly={!hasEditDatesAccess} 
				/>
			</Field>
			<Field amount={2}>
				<Input 
					label="Fecha inicio checadores" 
					calendar={{ 
						date: fromUnix(date.scanner_start).toJSDate(),
						mode: 'datetime',
						onSelected: v=>onDateFormChange('scanner_start')(v.getTime()/1000)
					}} 
					type={date.scanner_start > now ? 'warning' : 'normal'} 
					readonly={!hasEditDatesAccess} 
				/>
				<Input 
					label="Fecha fin checadores" 
					calendar={{ 
						date: fromUnix(date.scanner_end).toJSDate(),
						mode: 'datetime',
						onSelected: v=>onDateFormChange('scanner_end')(v.getTime()/1000)
					}} 
					type={date.scanner_end < now ? 'warning' : 'normal'} 
					readonly={!hasEditDatesAccess} 
				/>
			</Field>
		</Groupper>
		<Groupper style={{ maxWidth: 700, margin: '15px auto' }} title="Otra configuración" actions={hasAccess([UserAccess.DATES.SET_REFUNDABLE, UserAccess.DATES.SET_REFUNDABLE_COMPLETE], true) && (
			<Button text="Guardar" color="black" onClick={sendRefundOptions} />
		)}>
			<div className="fr option">
				<div className="info">
					<div className="title">Fila de espera</div>
					<div className="description">Si el evento tendrá mucho tráfico, se recomienda agregar una fila de espera.</div>
				</div>
				{sendingQueue ? (
					<Loader inline size={20} style={{ marginRight: 16 }} />
				) : hasAccess(!!date.queue_id ? UserAccess.DATES.REMOVE_QUEUE : UserAccess.DATES.ADD_QUEUE) ? (
					<Checkbox checked={!!date.queue_id} onChange={onQueueChange} />
				) : (
					<Icon name={!!date.queue_id ? 'check-circle' : "times-circle"} color={!!date.queue_id ? 'green' : 'black'} />
				)}
			</div>
			{!hasAccess([UserAccess.DATES.SET_REFUNDABLE, UserAccess.DATES.SET_REFUNDABLE_COMPLETE], true) && (
				<div className="fr option">
					<div className="info">
						<div className="title">Reembolsable</div>
						<div className="description">Solicita un cambio en la configuración de reembolsos del calendario.</div>
					</div>
					<Button text={refundRequest?.sent ? 'Solicitada' : 'Solicitar'} color={refundRequest?.sent ? null : "black"} iconName={refundRequest?.sent ? "check-circle" : null} onClick={showRefundRequest} />
				</div>
			)}
			{hasAccess(UserAccess.DATES.SET_REFUNDABLE) && <>
				<div className="fr option">
					<div className="info">
						<div className="title">Reembolsable Web</div>
						<div className="description">Permitir solicitudes de reembolso de compras web para este calendario.</div>
					</div>
					<Checkbox checked={!!date.refundable_web} onChange={onDateFormChange('refundable_web')} />
				</div>
				<div className="fr option">
					<div className="info">
						<div className="title">Reembolsable PDV</div>
						<div className="description">Permitir solicitudes de reembolso de compras PDV para este calendario.</div>
					</div>
					<Checkbox checked={!!date.refundable_pdv} onChange={onDateFormChange('refundable_pdv')} />
				</div>
			</>}
			{!hasAccess(UserAccess.DATES.SET_REFUNDABLE) && <>
				<div className="fr option">
					<div className="info">
						<div className="title">Reembolsable Web</div>
						<div className="description">Permitir solicitudes de reembolso de compras web para este calendario.</div>
					</div>
					<Icon name={!!date.refundable_web ? 'check-circle' : "times-circle"} color={!!date.refundable_web ? 'green' : 'black'} />
				</div>
				<div className="fr option">
					<div className="info">
						<div className="title">Reembolsable PDV</div>
						<div className="description">Permitir solicitudes de reembolso de compras PDV para este calendario.</div>
					</div>
					<Icon name={!!date.refundable_pdv ? 'check-circle' : "times-circle"} color={!!date.refundable_pdv ? 'green' : 'black'} />
				</div>
			</>}
			{!hasAccess(UserAccess.DATES.SET_REFUNDABLE_COMPLETE) ? (
				<div className="fr option last">
					<div className="info">
						<div className="title">Reembolsable Completo</div>
						<div className="description">Reembolsar toda la compra <b>INCLUYENDO cargos por servicio, entrega y forma de pago</b>.</div>
					</div>
					<Icon name={!!date.refundable_complete ? 'check-circle' : "times-circle"} color={!!date.refundable_complete ? 'green' : 'black'} />
				</div>
			) : (
				<div className="fr option last">
					<div className="info">
						<div className="title">Reembolsable Completo</div>
						<div className="description">Reembolsar toda la compra <b>INCLUYENDO cargos por servicio, entrega y forma de pago</b>.</div>
					</div>
					<Checkbox checked={!!date.refundable_complete} onChange={onDateFormChange('refundable_complete')} />
				</div>
			)}
		</Groupper>

		<UserLog user={date} style={{ maxWidth: 700, margin: '15px auto' }} />

		{hasAccess(UserAccess.DATES.DELETE_DATE) && (
			<div className="fr option last" style={{ justifyContent: 'center', marginTop: 20 }}>
				<Button color="red" text="Eliminar calendario" basic onClick={()=>setShownModal(ModalType.DELETE_EVENTDATE)} />
			</div>
		)}

		{/*===============================
			REEMBOLSABLE
		================================== */}
		<Modal size="tiny" open={refundRequestModal} onClose={bindClick(setRefundRequestModal)}>
			<Modal.Header>Solicitar calendario reembolsable</Modal.Header>
			<Modal.Content>
				<div className="fr option">
					<div className="info">
						<div className="title">Reembolsable Web</div>
						<div className="description">Permitir solicitudes de reembolso de compras web para este calendario.</div>
					</div>
					<Checkbox checked={refundRequest?.refundable_web} onChange={onRequestFormChange('refundable_web')} />
				</div>
				<div className="fr option">
					<div className="info">
						<div className="title">Reembolsable PDV</div>
						<div className="description">Permitir solicitudes de reembolso de compras pdv para este calendario.</div>
					</div>
					<Checkbox checked={refundRequest?.refundable_pdv} onChange={onRequestFormChange('refundable_pdv')} />
				</div>
				{refundRequest && (refundRequest.refundable_web || refundRequest.refundable_pdv) && hasAccess(UserAccess.DATES.REQUEST_REFUNDABLE_COMPLETE) ? (
					<div className="fr option">
						<div className="info">
							<div className="title">Reembolsable Completo</div>
							<div className="description">Reembolsar toda la compra <b>INCLUYENDO cargos por servicio, entrega y forma de pago</b>.</div>
						</div>
						<Checkbox checked={refundRequest?.refundable_complete} onChange={onRequestFormChange('refundable_complete')} />
					</div>
				) : null}
				<Field label="Comentarios" style={{ marginBottom: 15, marginTop: 0 }}>
					<textarea placeholder="Explica la razón por la cual se está haciendo la solicitud de reembolso" value={refundRequest?.comments} onChange={onRequestFormChange('comments', true)} rows={5}></textarea>
				</Field>
				<Message>
					Se le enviará un correo a los administradores con acceso para marcar calendarios como reembolsable con la información ingresada en este formulario.
				</Message>
				<Message list={modalPrompts} style={{ marginTop: 5 }} type="error" />
			</Modal.Content>
			<Modal.Actions>
				<Button text="Cerrar" basic onClick={bindClick(setRefundRequestModal)} />
				<Button text="Enviar" color="black" onClick={sendRefundableRequest} />
			</Modal.Actions>
		</Modal>
		{/*===============================
			ADD SECTION
		================================== */}
		<Modal size="tiny" open={shownModal===ModalType.SECTION_ADD} onClose={bindClick(setShownModal)}>
			<Modal.Header>Agregar sección</Modal.Header>
			<Modal.Content>
				<div className="fr items selectable">
					{missing_sections.map(a=>(
						<div className="item" key={`addsect-${a.section_id}`} onClick={()=>addSection(a.section_id)}>
							<div style={{ minWidth: 80, height: 80, backgroundColor: '#f0f0f0', borderRadius: 8, marginRight: 15, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
								<Icon name="image" color={'gray'} style={{ margin: 0 }} />
							</div>
							<div style={{ display: 'block', width: '100%' }}>
								<div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
									<div className="left">
										<div className="meta" style={{ fontSize: 12, color: 'gray', lineHeight: '12px' }}>Sección #{a.section_id}</div>
										<div className="title">{a.section_name}</div>
									</div>
									<div className="right" style={{ textAlign: 'center', height: 36 }}>
										<Icon name={a.numbered ? 'chair' : 'hashtag'} style={{ margin: 'auto', fontSize: 16, display: 'block' }} />
										{a.infinite && !a.numbered ? (
											<Icon name="infinity" style={{ fontSize: 16, margin: 0 }} />
										) : (
											addCommas(a.ticket_count, false)
										)}
									</div>
								</div>
								<div className="description" style={{ color: 'gray', lineHeight: '14px', fontSize: 12 }}>
									{a.description}
								</div>
							</div>
						</div>
					))}
				</div>
			</Modal.Content>
			<Modal.Actions>
				<Button text="Regresar" basic onClick={bindClick(setShownModal)} />
			</Modal.Actions>
		</Modal>

		{/*===============================
			SEATMAP
		================================== */}
		<Modal size="large" open={!!selectedSeatmap} onClose={bindClick(setSelectedSeatmap)}>
			<Modal.Header>
				Butacas: {selectedSeatmap ? selectedSeatmap.section_name : null}
			</Modal.Header>
			{selectedSeatmap ? <Modal.Content style={{ padding: 0 }}>
				<Seatmap dateId={date.date_id} sectionId={selectedSeatmap.section_id} />
			</Modal.Content> : null}
			<Modal.Actions>
				<Button text="Regresar" onClick={bindClick(setSelectedSeatmap)} />
			</Modal.Actions>
		</Modal>

		{/*===============================
			HOLD SEATS
		================================== */}
		<SectionHoldModal
			open={!!selectedSection && shownModal === ModalType.SECTION_HOLD}
			onClose={()=>{
				setShownModal(null)
				setSelectedSection(null);
			}}
			title='Reservar Butacas'
			dateId={date.date_id}
			sectionId={selectedSection?.section_id}
			infinite={selectedSection?.infinite}
		/>

		{/*===============================
			DELETE CALENDAR
		================================== */}

		<Modal open={shownModal === ModalType.DELETE_EVENTDATE} onClose={bindClick(setShownModal)} size="mini">
			<Modal.Header>Eliminar Calendario</Modal.Header>
			<Modal.Content>
				<Header size='small' text='¿Eliminar el calendario?' />
				<ul style={{ paddingLeft: 15 }}>
					<li>Una vez eliminada la fecha, no podrá ser recuperada</li>
					<li>Si hay boletos vendidos en el calendario <b>NO</b> será eliminado</li>
				</ul>
				<Field label='Confirmación' comment={'Ingresa el siguiente texto para eliminar el calendario'}>
					<Input
						placeholder={props.event.event_name}
						comment={`"${props.event.event_name}"`}
						commentStyle={{ fontWeight: 'bold' }}
						value={deleteConfirm}
						onChange={setDeleteConfirm}
					/>
				</Field>
			</Modal.Content>
			<Modal.Actions>
				<Button text='Cancelar' basic onClick={bindClick(setShownModal)} />
				<Button text='Eliminar' color={'red'} onClick={deleteEventDate} />
			</Modal.Actions>
		</Modal>

		{/*===============================
			SORT PRICES
		================================== */}
		<Modal size="tiny" open={shownModal === ModalType.PRICE_SORT}>
			<Modal.Header>Ordenar precios</Modal.Header>
			<Modal.Content>
				<Message type="info" style={{ marginBottom: 10 }} centered>
					Arrastra los precios para ordenarlos <br />
					<b>{selectedSection?.section_name}</b>
				</Message>
				<SortableList onSortEnd={onSortPriceEnd} className="fr items selectable card" draggedItemClassName="dragged" style={{ margin: 0, userSelect: 'none' }}>
					{pricesSort?.map(p=><SortableItem key={p?.price_id} >
						<div className="fr item selectable">
							<div className="left">
							<div className="meta" style={{ color: 'gray', fontSize: 12 }}>ID: {p?.price_id}</div>
							<b>{p?.price_name}</b>
							</div>
						</div>
					</SortableItem>)}
				</SortableList>
				<Message list={modalPrompts} type="error" style={{ marginTop: 10 }} />
			</Modal.Content> 
			<Modal.Actions>
				<Button text="Regresar" basic onClick={bindClick(setShownModal)} />
				<Button text="Guardar" color="black"  onClick={onSavePriceOrder} />
			</Modal.Actions>
		</Modal>

		{/*===============================
			SORT SECTIONS
		================================== */}
		<Modal size="tiny" open={shownModal === ModalType.SECTION_SORT}>
			<Modal.Header>Ordenar secciones</Modal.Header>
			<Modal.Content>
				<Message type="info" style={{ marginBottom: 10 }} centered>
					Arrastra las secciones para ordenarlas <br />
					<b>{date.venue_name}</b>
				</Message>
				<SortableList onSortEnd={onSortSectionEnd} className="fr items selectable unfitted card" draggedItemClassName="dragged" style={{ margin: 0, userSelect: 'none' }}>
					{sectionsSort.map(p=><SortableItem key={p?.section_id} >
						<div className="fr item selectable">
							<div className="left">
							<div className="meta" style={{ color: 'gray', fontSize: 12 }}>ID: {p?.section_id}</div>
							<b>{p?.section_name}</b>
							</div>
						</div>
					</SortableItem>)}
				</SortableList>
				<Message list={modalPrompts} type="error" style={{ marginTop: 10 }} />
			</Modal.Content> 
			<Modal.Actions>
				<Button text="Regresar" basic onClick={bindClick(setShownModal)} />
				<Button text="Guardar" color="black" onClick={onSaveSectionOrder} />
			</Modal.Actions>
		</Modal>

		
		{/*===============================
			DATE TICKET COUNT
		================================== */}
		<Modal size="mini" open={shownModal===ModalType.EDIT_SECTION_TICKET_COUNT} onClose={bindClick(setShownModal)}>
			<Modal.Header>Editar aforo</Modal.Header>
			{!!selectedSection && (
				<Modal.Content>
					<Table details fitted style={{ borderBottom: '1px solid rgba(0,0,0,0.1)' }}>
						<Table.Body data={[
							['ID', selectedSection.section_id],
							['Nombre', selectedSection.section_name],
							['Aforo recinto', addCommas(selectedSection.ticket_count, false)],
						]} />
					</Table>
					<Input label="Aforo" comment="Este aforo se aplicará solamente a este calendario" style={{ marginTop: 15 }} value={(selectedSection.date_ticket_count || '').toString()} onChange={bindFormChange(selectedSection, setSelectedSection)('date_ticket_count')} />
					<Message list={modalPrompts} type="error" style={{ marginTop: 15 }} />
				</Modal.Content>
			)}
			<Modal.Actions>
				<Button text="Close" basic onClick={bindClick(setShownModal)} />
				<Button text="Guardar" color="black" onClick={onSaveSectionTicketCount} />
			</Modal.Actions>
		</Modal>


		{/* ===============================
			REMOVE DATE SECTION
		=============================== */}
		<Modal size="tiny" open={shownModal===ModalType.REMOVE_DATE_SECTION} onClose={bindClick(setShownModal)}>
			<Modal.Header>Eliminar sección</Modal.Header>
			{selectedSection && <Modal.Content>
				<Header text={'Eliminar sección'} subtext={'Se eliminará la sección y sus precios del calendario'} />
				<Table details>
					<Table.Head title="Detalles" />
					<Table.Body data={[
						['ID', selectedSection.section_id],
						['Nombre', selectedSection.section_name],
						['Tipo', selectedSection.numbered ? 'Numerada' : 'General']
					]} />
				</Table>
				<Message centered type="info" style={{ marginTop: 15 }}>
					Cualquier boleto que se haya vendido en esta sección no se eliminará ni se cancelará.
					<br />
					En el caso que se vuelva a agregar la sección {' '}
					<b>
						{!!selectedSection.numbered ? (
							'no se recreará el mapa de butacas'
						) : (
							'los boletos vendidos seguirán afectando el aforo'
						)}
					</b>
				</Message>
			</Modal.Content>}
			<Modal.Actions>
				<Button text="Close" basic onClick={bindClick(setShownModal)} />
				<Button text="Eliminar" color="red" onClick={sendRemoveSection} />
			</Modal.Actions>
		</Modal>

		{date && (
			<EventDateStatusModal open={shownModal===ModalType.SECTION_STATUS} dateId={date?.date_id} onClose={bindClick(setShownModal)} />
		)}
	</div>
}

export default EventDateComponent;